module.exports = "../static/media/banner_poster.194f28a9.png";